// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UsersCount_wrapper__2upPz","listWrapper":"UsersCount_listWrapper__1ef_q","listItem":"UsersCount_listItem__3pVSZ"};